import { render } from "./LoginBackground.vue?vue&type=template&id=1d564339&scoped=true&ts=true"
import script from "./LoginBackground.vue?vue&type=script&lang=ts"
export * from "./LoginBackground.vue?vue&type=script&lang=ts"

import "./LoginBackground.vue?vue&type=style&index=0&id=1d564339&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d564339"]])

export default __exports__